


































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { config } from "@/req/competition";
import homeTop from "./homeTop.vue";
import mainBody from "../studio/mainBody/index.vue";
import switchLive from "./compconent/switchLive.vue";
import headerTitle from "./compconent/headerTitle.vue";
import advance from "./compconent/advance.vue";
import association from "./compconent/association.vue";
import match from "./compconent/match.vue";
import fixtureList from "./compconent/fixtureList.vue";
import ranking from "./compconent/ranking.vue";
import award from "./compconent/award.vue";
@Component({
  components: {
    homeTop,
    mainBody,
    switchLive,
    headerTitle,
    advance,
    association,
    match,
    fixtureList,
    ranking,
    award,
  },
})
export default class Home extends Vue {
  public active = 0;
  public list: any = [];
  public data: any = {};
  public navlist = [
    {
      name: "直播",
      link: "#zhibo",
    },
    {
      name: "赛程预告",
      link: "#zhibo",
    },
    {
      name: "参赛公会",
      link: "#zhibo",
    },
    {
      name: "十大赛程",
      link: "#zhibo",
    },
    {
      name: "赛事奖励",
      link: "#saishijiangli",
    },
    {
      name: "十大排名",
      link: "#zhibo",
    },
    {
      name: "赛事介绍",
      link: "#saishijieshao",
    },
  ];

  public scrollTop: any = 0;
  public showToTop = -1;
  public imgShow = false;
  public followShow = false;
  public contactShow = false;
  public animeClass = false;
  public timerShow = false;

  public mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getList();
  }
  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  public handleScroll() {
    const that = this;
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    that.scrollTop = scrollTop;
    const $advance: any = this.$refs.advance;
    const $association: any = this.$refs.association;
    const $match: any = this.$refs.match;
    const $award: any = this.$refs.award;
    const $ranking: any = this.$refs.ranking;
    const $introduce: any = this.$refs.introduce;
    if (that.scrollTop < 380) {
      that.showToTop = -1;
    }
    if (that.scrollTop > 380) {
      that.showToTop = 0;
    }
    if (that.scrollTop >= $advance.offsetTop - 50) {
      that.showToTop = 1;
    }
    if (that.scrollTop >= $association.offsetTop - 50) {
      that.showToTop = 2;
    }
    if (that.scrollTop >= $match.offsetTop - 50) {
      that.showToTop = 3;
    }
    if (that.scrollTop >= $award.offsetTop - 50) {
      that.showToTop = 4;
    }
    if (that.scrollTop >= $ranking.offsetTop - 50) {
      that.showToTop = 5;
    }
    if (that.scrollTop >= $introduce.offsetTop - 50) {
      that.showToTop = 6;
    }
  }
  public toTop(index) {
    const $advance: any = this.$refs.advance;
    const $association: any = this.$refs.association;
    const $match: any = this.$refs.match;
    const $award: any = this.$refs.award;
    const $ranking: any = this.$refs.ranking;
    const $introduce: any = this.$refs.introduce;
    this.showToTop = index;
    let num: any = 0;
    if (index == 0) {
      num = 400;
    }
    if (index == 1) {
      num = $advance.offsetTop - 50;
    }
    if (index == 2) {
      num = $association.offsetTop - 50;
    }
    if (index == 3) {
      num = $match.offsetTop - 50;
    }
    if (index == 4) {
      num = $award.offsetTop - 50;
    }
    if (index == 5) {
      num = $ranking.offsetTop - 50;
    }
    if (index == 6) {
      num = $introduce.offsetTop - 50;
    }
    window.scroll({
      top: num,
      left: 0,
      behavior: "smooth",
    });
  }
  public async getList() {
    // const res = await config();
    // this.data = res;
    axios.get(this.$HTTP_API.competition.config).then((response) => {
      this.data = response.data;
    });
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }
  public tabChange(i) {
    this.active = i;
  }
  public toLink(link) {
    location.hash = link;
  }
  public toQQ() {
    window.open(`http://shang.qq.com/wpa/qunwpa?idkey=${this.data.ios_key}`);
  }
}
